<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Create new...') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <label for="newContentName">{{ _('Name') }}</label>
            <input ref="name" class="form-control" type="text" id="newContentName" v-model="name" :placeholder="_('Enter a name for the content')" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <label for="newContentType">{{ _('Type') }}</label>
            <select class="form-control" v-model="type">
              <option value="BreadcrumbNavi">{{ _('BreadcrumbNavi') }}</option>
              <option value="ContentImage">{{ _('ContentImage') }}</option>
              <option value="FooterNavi">{{ _('FooterNavi') }}</option>
              <option value="Iframe">{{ _('Iframe') }}</option>
              <option value="Navi">{{ _('Navi') }}</option>
              <option value="RichText">{{ _('RichText') }}</option>
              <option value="Search">{{ _('Search') }}</option>
              <option value="Search2">{{ _('Search2') }}</option>
              <option value="Search2Result">{{ _('Search2Result') }}</option>
              <option value="TopNavi">{{ _('TopNavi') }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="selected" :disabled="!canSubmit"><i class="fa fa-fw fa-save"></i> {{ _('OK') }}</button>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  props: ['selectedProducts'],
  data () {
    return {
      search: '',
      visibility: {
        local: true,
        global: false,
        other: false
      },
      name: '',
      type: null
    }
  },
  computed: {
    ...mapGetters(['shopId', 'baseDomain', 'locale', 'apiKey']),
    canSubmit () {
      return this.name && this.type
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    selected () {
      this.$emit('selected', {
        name: this.name,
        type: this.type
      })
    },
    async focusName () {
      await nextTick()
      if (this.$refs.name) {
        this.$refs.name.focus()
      }
    }
  }
}
</script>
